import { env } from '@shared/utils/env';

import type { IResourceSettings } from './types';

const DEFAULT_BUCKET_BASE = env.APP_RESOURCES_BASE_URL;

export const DEFAULT_SETTINGS: IResourceSettings = {
  base: DEFAULT_BUCKET_BASE,
  paths: {
    images: '/img',
    icons: '/img/mingcute_icons',
    countryFlags: `/img/flags`,
    currencyFlags: `/img/currencies`,
  },
};
